import Component1 from "./1";
import Component2 from "./2";
import Component3 from "./3";
import Component4 from "./4";
import Component5 from "./5";
import Component6 from "./6";
import Component7 from "./7";
import Component8 from "./8";
import Component9 from "./9";
import Component10 from "./10";
import Component11 from "./11";
import Component12 from "./12";
import Component13 from "./13";
import Component14 from "./14";
import Component15 from "./15";
import Component16 from './16';
import Component17 from './17';
import Component18 from './18';
import Component19 from './19';
import Component20 from './20';
import Component21 from './21';
import Component22 from './22';
export default {
  NAVBAR_1: Component1,
  NAVBAR_2: Component2,
  NAVBAR_3: Component3,
  NAVBAR_4: Component4,
  NAVBAR_5: Component5,
  NAVBAR_6: Component6,
  NAVBAR_7: Component7,
  NAVBAR_8: Component8,
  NAVBAR_9: Component9,
  NAVBAR_10: Component10,
  NAVBAR_11: Component11,
  NAVBAR_12: Component12,
  NAVBAR_13: Component13,
  NAVBAR_14: Component14,
  NAVBAR_15: Component15,
  NAVBAR_16: Component16,
  NAVBAR_17: Component17,
  NAVBAR_18: Component18,
  NAVBAR_19: Component19,
  NAVBAR_20: Component20,
  NAVBAR_21: Component21,
  NAVBAR_22: Component22,
};
